import { render, staticRenderFns } from "./CompanyStockRelationshipChart.vue?vue&type=template&id=70497db8&scoped=true"
import script from "./CompanyStockRelationshipChart.vue?vue&type=script&lang=ts"
export * from "./CompanyStockRelationshipChart.vue?vue&type=script&lang=ts"
import style0 from "./CompanyStockRelationshipChart.vue?vue&type=style&index=0&id=70497db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70497db8",
  null
  
)

export default component.exports